@if (config?.label) {
  <label
    class="form-control__label"
    data-test-id="ssnMultiFieldLabelWrapper"
    [ngClass]="{ 'is-required': !!config.required }"
  >
    <div
      class="u-flex u-alignBaseline u-maxX"
      data-test-id="ssnMultiFieldLabelContainer"
    >
      <p class="t-data t-bold" data-test-id="ssnMultiFieldLabel">
        {{ config?.label }}
        @if (required) {
          <span data-test-id="ssnMultiFieldLabelRequired">*</span>
        }
      </p>
    </div>
  </label>
}

<div
  class="ssn-group__controls"
  data-test-id="ssnMultiFieldFormControlsWrapper"
>
  @for (ctrl of ssnControls; track ctrl; let i = $index) {
    <form-control
      [attr.data-test-id]="'ssnMultiFieldFormControl_' + i"
      [group]="formGroup"
      [config]="ctrl"
      [control]="formGroup.get(ctrl.prop)"
    >
    </form-control>
  }
</div>

@if (errors) {
  <div class="u-flex ssn-group__error" data-test-id="ssnMultiFieldErrorWrapper">
    <i
      class="icon icon--small icon--error"
      data-test-id="ssnMultiFieldErrorIcon"
      >warning</i
    >
    <p
      [attr.aria-label]="displayedError"
      class="t-caption t-error"
      data-test-id="ssnMultiFieldErrorMessage"
    >
      {{ config.message }}
    </p>
  </div>
}
